import { render } from "./CxResetForm.vue?vue&type=template&id=13a565ec&ts=true"
import script from "./CxResetForm.vue?vue&type=script&lang=ts"
export * from "./CxResetForm.vue?vue&type=script&lang=ts"

import "./CxResetForm.vue?vue&type=style&index=0&id=13a565ec&lang=less"

import exportComponent from "/home/ec2-user/workspace/_ui_production_production-1.59.1/microfrontends/conx-ui-login/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__